module.exports = __webpack_public_path__ + "img/tlosp_steemenginex.8745ba5.png";